<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style src='quasar/dist/quasar.css'></style>
<style src='quasar/dist/quasar.addon.css'></style>
<style src='@quasar/extras/material-icons/material-icons.css'></style>
<style src='@quasar/extras/material-icons-outlined/material-icons-outlined.css'></style>
<style src='@quasar/extras/material-symbols-outlined/material-symbols-outlined.css'></style>
<style src='@/assets/styles/index.less' lang="less"></style>
<style src='md-editor-v3/lib/style.css'></style>